import React from "react";
import { Container } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DatatableTables from "./DatatableTables (1)";


const Audittrial = () => {
    return (
        <React.Fragment>
            {/* <div className="page-content"> */}
            {/* <Container fluid> */}
            {/* Render Breadcrumbs */}
            {/* <Breadcrumbs title="Setting" breadcrumbItem="Users" /> */}
            <DatatableTables />

            {/* </Container> */}
            {/* </div> */}
        </React.Fragment>
    )
}

export default Audittrial
